import { Skeleton } from "@/components/ui/skeleton";
import { IconLoader2 } from "@tabler/icons-react";

interface Props {
    className?: string;
    nopulse?: boolean;
}

export default function LoadingSkeleton({ className, nopulse }: Props) {
    return (
        <div className={`relative aspect-video w-full rounded-lg bg-card`}>
            <Skeleton
                nopulse={nopulse}
                className={`absolute aspect-video h-full w-full rounded-lg ${className}`}
            />
        </div>
    );
}
